import $ from 'jquery';
class AddWish {
    constructor() {
        this.events();
    }

    events() {
        $("#package-section-info").on("click", "#add-wishlist",this.wish.bind(this));
        $("#package-section-info").on("click", "#add-wishlist-mobile",this.wishMobile.bind(this));
        $(".package-box-thumb").on("click", ".add-to-wishlist-btn",this.wishItem.bind(this));
    }

    wishItem(e){
        var thisbtn = $(e.target).closest(".add-to-wishlist-btn");
        var thisParent = $('.package-box');
        var pID = thisbtn.data("id");
        console.log(pID);
        var formData = {
            "action":"wished",
            "id":pID
        };

        $.ajax({
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
            },
            dataType: "json",
            url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: formData,
            success: (response) => {
                if(response.status=='1'){
                    thisbtn.addClass("active");
                    thisbtn.find('span.text').text('Added to Wishlist');
                }else{
                    thisbtn.removeClass("active");
                    thisbtn.find('span.text').text('Add to Wishlist');
                }

            },
            error: (response) => {
                console.log(response);
            }
        });
    }

    wishMobile(e){
        var thisbtn = $(e.target);
        var thisParent = $('#package-section-info');
       

        var formData = {
            "action":"wished",
            "language":ootlahData.language,
            "id":ootlahData.id
        };

        $.ajax({
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
            },
            dataType: "json",
            url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: formData,
            success: (response) => {
                if(response.status=='1'){
                    thisParent.find('#add-wishlist-mobile').addClass("active");
                    thisParent.find('#add-wishlist-mobile').find('i').removeClass('bi-heart');
                    thisParent.find('#add-wishlist-mobile').find('i').addClass('bi-heart-fill');
                }else{
                    thisParent.find('#add-wishlist-mobile').removeClass("active");
                    thisParent.find('#add-wishlist-mobile').find('i').removeClass('bi-heart-fill');
                    thisParent.find('#add-wishlist-mobile').find('i').addClass('bi-heart');
                }
               
            },
            error: (response) => {
                console.log(response);
            }
        });
    }

    wish(e){
        var thisbtn = $(e.target);
        var thisParent = $('#package-section-info');
        thisParent.find('#add-wishlist>span.indicator-progress').show();
        thisParent.find('#add-wishlist>span.wish-icon').hide();

        var formData = {
            "action":"wished",
            "language":ootlahData.language,
            "id":ootlahData.id
        };

        $.ajax({
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
            },
            dataType: "json",
            url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: formData,
            success: (response) => {
                if(response.status=='1'){
                    thisParent.find('#add-wishlist').addClass("active");
                    thisParent.find('#add-wishlist>span.indicator-label').text('Added to Wishlist');

                }else{
                    
                    thisParent.find('#add-wishlist').removeClass("active");
                    thisParent.find('#add-wishlist>span.indicator-label').text('Add to Wishlist');

                }

                thisParent.find('#add-wishlist>span.indicator-progress').hide();
                thisParent.find('#add-wishlist>span.wish-icon').show();
            },
            error: (response) => {
                console.log(response);
            }
        });
    }

}

export default AddWish